// extracted by mini-css-extract-plugin
module.exports = {"custom-carousel":"custom-carousel_custom-carousel__1zx9Q","carousel-images":"custom-carousel_carousel-images__3G7-U"};